import { render, staticRenderFns } from "./data-collection-item.vue?vue&type=template&id=30c9c8ba"
import script from "./data-collection-item.vue?vue&type=script&lang=js"
export * from "./data-collection-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports